import { HeartPulse, ShieldCheck, Truck, Microscope, ClipboardCheck, LayoutGrid, UserCircle, Phone, Mail, MapPin, Clock } from 'lucide-react';

export const navigation = [
  { name: 'Forside', href: '/' },
  { 
    name: 'Produkter', 
    href: '/medimi-smart',
    children: [
      { name: 'FlexSuite', href: '/medimi-smart' },
      { name: 'TIM', href: '/medimi-smart/tim' },
      { name: 'APP', href: '/medimi-smart/flexsmartapp' },
      { name: 'Mobili', href: '/medimi-smart/mobili' },
    ]
  },
  { name: 'Folder', href: '/folder' },
  { name: 'Video', href: '/video' },
  { name: 'Om os', href: '/om-os' },
  { name: 'Instrukser', href: '/instruktioner' },
  { name: 'E-læring', href: '/e-laering', target: '_blank' },
];

export const features = [
  {
    title: 'Intelligent påmindelse',
    description: 'Medimi®Smart sikrer, at borgeren tager sin medicin til tiden gennem lys- og lydsignaler.',
    icon: HeartPulse,
    iconClass: 'fa-light fa-bell-on',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=200,quality=90,format=auto/assets/05bb43a3-4ef2-4771-9030-58242fc7345d/chatgpt-image-2-jul-2026-08-53-35.png',
  },
  {
    title: 'Automatisk opfølgning & tryghed',
    description: 'Hvis borgeren ikke tager sin medicin via de forskellige påmindelser, kontakter Sundhedssupporten borgeren med opkald, såfremt der ikke fås fat i borgeren, kontaktes kommunen straks og der sendes en medarbejder ud og ser til borgeren – det kunne jo være at borgeren var faldet og ikke kunne komme til telefonen. Det giver en stor tryghed at vide at der er mennesker bag løsningen og som reagerer såfremt det bliver nødvendigt.',
    icon: ShieldCheck,
    iconClass: 'fa-light fa-comment-sms',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=200,quality=90,format=auto/assets/05bb43a3-4ef2-4771-9030-58242fc7345d/eoj.png',
  },
  {
    title: 'Sikker og opdateret medicindosering',
    description: 'Hver medicinkassette er udstyret med en QR-kode, som Medimi®Smart scanner før dosering.',
    icon: Truck,
    iconClass: 'fa-light fa-qrcode',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=200,quality=90,format=auto/assets/05bb43a3-4ef2-4771-9030-58242fc7345d/bil.png',
  },
];

export const services = [
  {
    title: 'Ordination & FMK',
    description: 'Lægerne ordinerer og udskriver recepter helt som normalt',
    icon: ClipboardCheck,
    iconClass: 'fa-light fa-file-prescription',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=200,quality=90,format=auto/assets/05bb43a3-4ef2-4771-9030-58242fc7345d/papir.png',
  },
  {
    title: 'FlexSuite System',
    description: 'Vores fælles IT administrationssystem',
    icon: LayoutGrid,
    iconClass: 'fa-light fa-cloud-binary',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=200,quality=90,format=auto/assets/05bb43a3-4ef2-4771-9030-58242fc7345d/flexsuite.png',
  },
  {
    title: 'Apotekssamarbejde',
    description: 'Tæt samarbejde med de lokale apotekere for pakning af medicin i vores kassetter og genopfyldning af disse i TIM (MedimiSmart) - ude i borgers eget hjem.',
    icon: Microscope,
    iconClass: 'fa-light fa-prescription-bottle-medical',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=200,quality=90,format=auto/assets/05bb43a3-4ef2-4771-9030-58242fc7345d/medidcin.png',
  },
];

export const contactInfo = [
  {
    name: 'Kontaktperson',
    value: 'Johnny Andersen',
    icon: UserCircle,
  },
  {
    name: 'Stilling',
    value: 'CMO',
    icon: ClipboardCheck,
  },
  {
    name: 'Telefon',
    value: '+45 40 83 08 30',
    icon: Phone,
  },
  {
    name: 'Email',
    value: 'info@mediccare.dk',
    icon: Mail,
  },
];
